import { createSagaActionTypes } from "../../../utils/actionFactory";

export const CHANGE_PASS = "CHANGE_PASS";

export const actions = createSagaActionTypes("CHANGE_PASS", [CHANGE_PASS]);
